<template>
  <div>
    <div class="header">
      <video
        playsinline="playsinline"
        autoplay="autoplay"
        muted="muted"
        loop="loop"
      >
        <!--<source src="../assets/header.mp4" type="video/mp4" />-->
        <source src=" https://codelos-public-media.s3.eu-central-1.amazonaws.com/assets/videos/header.mp4" type="video/mp4" />
      </video>
      <div class="overlay">
        <div class="nav custom">
          <ul>
            <!--<li class="list-item">
              <a>Quick Starts</a>
            </li>-->
            <li class="list-item">
              <a href="#/auth">
                Login
                <!--<span class="arrow-bottom">></span>-->
              </a>
              <!--<ul class="dropdown" v-if="dropdown1">
                <li>Lastgang Parser</li>
                <li>Lastgang Funktionen</li>
                <li>Lastgang Ausrollen</li>
                <li>Lastgang Prognose</li>
                <li>Lastgang Zerlegen</li>
                <li>Lastgang Hedgen</li>
              </ul>-->
            </li>
            <li v-if="!isMobile()" class="list-item">
              <a class="btn-red" href="#/auth">
                <span class="free">Sign up free</span>
              </a>
            </li>
            <li v-if="isMobile()" class="list-item">
              <a href="#/auth">
                <span style="text-decoration: none; padding-right: 6px; padding-left: 12px"
                  ></span
                >Sign up free 
              </a>
            </li>
          </ul>
        </div>
        <a href="/">
          <div class="logo-wrapper">
            <div class="codelos-logo">
              <svg
                style="transform: rotate(11deg)"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                viewBox="-0.5 -0.5 538 439"
                content='<mxfile host="www.draw.io" modified="2020-07-07T16:35:48.281Z" agent="5.0 (Macintosh; Intel Mac OS X 10_15_5) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/83.0.4103.116 Safari/537.36" version="13.3.6" etag="TN6qjrQkVujqEMhigEsy" type="device"><diagram id="g3IF2AxwIblVb2gJ5hIN">5Vhdc6MgFP01edyOgPjx2Kbt7sPuTGf6sM8kUmUWxUHSpPvrFyNoRBudNMnOtD4kerlcuOdcDuICLfPdd0nK7JdIKF9AL9kt0P0CQuDDQP/VlrfGEka4MaSSJcapMzyzv9QYPWPdsIRWPUclBFes7BvXoijoWvVsREqx7bu9CN4ftSQpHRie14QPrb9ZorLGGsGws/+gLM3syCCIm5acWGeTSZWRRGwPTOhhgZZSCNXc5bsl5TV4Fpem3+M7re3EJC3UnA6w6fBK+MbkZual3myyqRSb0rhRqehuDGKysu7ecAqgTUxXBBU5VfJNu9hAtospBmQetx2y2LpkB6j61kgMm2kbuktY35icx/NH0/nr9IuE1v5gge62GVP0uSTrunWry1vbMpVz01wpKf60RQGxNr0wzpeCC7kPh7z9pe3vQnoIHTwOndeHDoAhdgiMYAf9M2DnT2NXZ8f0uvlJVpQ/iYopJgrdtBJKiVyDYB1uOUvrBiVcQDNS1sHyXVpryc2KVGx9Q+R6DzaR6rZI96N5NxgjH0T6B4VBhPSSQ3e0SLr2GHuhF0Mf+xGOMYzH6ZJCETPLb7E35O9xf7V9x1rOwCz0cI9Z6A2Zbdk/ZLY1foRZPM1sjWytpPqpEAWdXAVNAJoMhHUSkUMdGEnY2iTlmrfXfvgxEMwIT4LpgTvAY398KdkQldjINTW9DhXVCYRgP5C70nTNplQN4uwpabOexVIwgyXO9Z5Ip3WLVGWzUb6wXa11DoVgZCGcU8iQh4aif4TsjxR3eGXYLqsTbtmGI7vnhYCM/m/9XUeIW0BbgMHVAI6/kAzbfQ6dKLuBQ1NwMdm1G8OXoGUcXRidyBJw4rgzOSNLYJql5mTTf+UD0dEtbc5x57ig+NipVDxU7HDsxc4/wtpcRQEzznsXqF3wzgnwSsULe4AHToC5tduPAlyhOmPpzjiUfjqSHHRP1BfcDxNejqMZh9/PtgmAuK9cgw8ws1eS+8XHfVk6mSf92H07a9y7L5Do4R8=</diagram></mxfile>'
              >
                <g style="fill: rgb(255, 255, 255); stroke: rgb(255, 255, 255)">
                  <rect
                    x="112"
                    y="115"
                    width="310"
                    height="240"
                    rx="36"
                    ry="36"
                    stroke-width="25"
                    pointer-events="all"
                  />
                  <path
                    d="M 306 115 L 336 45"
                    stroke-width="25"
                    stroke-miterlimit="10"
                    pointer-events="stroke"
                  />
                  <ellipse
                    cx="340"
                    cy="30"
                    rx="25"
                    ry="25"
                    stroke-width="10"
                    pointer-events="all"
                  />
                  <path
                    d="M 12 235 L 72 165"
                    fill="none"
                    stroke-width="25"
                    stroke-miterlimit="10"
                    pointer-events="stroke"
                  />
                  <path
                    d="M 72 285 L 22 226"
                    fill="none"
                    stroke-width="25"
                    stroke-miterlimit="10"
                    pointer-events="stroke"
                  />
                  <path
                    d="M 524 216 L 464 285"
                    fill="none"
                    stroke-width="25"
                    stroke-miterlimit="10"
                    pointer-events="stroke"
                  />
                  <path
                    d="M 464 165 L 514 225"
                    fill="none"
                    stroke-width="25"
                    stroke-miterlimit="10"
                    pointer-events="stroke"
                  />
                  <path
                    d="M 202 425 L 232 355"
                    fill="none"
                    stroke-width="25"
                    stroke-miterlimit="10"
                    pointer-events="stroke"
                  />
                </g>
                <g style="fill: rgb(254, 52, 102); stroke: rgb(254, 52, 102)">
                  <path
                    d="M 250.53 302.21 C 230.23 295.13 216.73 275.85 217 254.35 C 217.28 232.85 231.28 213.93 251.76 207.38"
                    stroke-width="25"
                    stroke-miterlimit="10"
                    transform="rotate(-90,267,255)"
                    pointer-events="all"
                    style="stroke: none"
                  />
                  <ellipse
                    cx="331"
                    cy="200"
                    rx="25"
                    ry="25"
                    stroke-width="10"
                    pointer-events="all"
                    style="fill: rgb(254, 52, 102); stroke: rgb(254, 52, 102)"
                  />
                  <ellipse
                    cx="207"
                    cy="201"
                    rx="25"
                    ry="25"
                    stroke-width="10"
                    pointer-events="all"
                  />
                </g>
                <defs />
              </svg>
            </div>
            <div class="title">
              &nbsp;&nbsp;Snappost
            </div>
          </div>
        </a>
        <div class="content">
          <div class="container">
            <h1>
              Create beautiful social media ads in seconds
            </h1>
            <a class="btn-red" href="#/auth"
              >Try for free</a
            >
          </div>
        </div>
      </div>
    </div>
    <section>
      <ul class="inline-list">
        <li>
          <a href="#/impressum">Impressum</a>
        </li>
        <li>
          <a href="#/privacy">Datenschutzerklärung</a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script scoped>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
//import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
export default {
  name: "Home",
  data() {
    return {
      dropdown1: true,
    };
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  components: {},
};
</script>

<style>
@import "https://use.fontawesome.com/releases/v5.6.3/css/all.css";
@import "https://fonts.googleapis.com/css?family=Hammersmith+One|Nunito|Orbitron:500|Poiret+One";

*,
*::before,
*::after {
  box-sizing: unset;
}

html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeSpeed;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.header ul.dropdown li {
  display: list-item;
  background: rgb(12, 13, 17, 0.75);
  padding: 16px 25px 1px;
}

.dropdown {
  position: absolute;
  background-color: black;
  display: block;
  margin-top: 10px;
}

.arrow-bottom {
  transform: rotate(90deg) scaleY(2);
  display: inline-block;
  line-height: 7px;
  font-size: 13px;
  font-weight: 800;
  margin-left: 8px;
}

a {
  cursor: pointer;
  color: inherit;
}

a:hover {
  color: inherit;
}

.inline-list {
  list-style: unset;
}

.inline-list li {
  display: inline-block;
  margin-right: 15px;
}

.inline-list li a:hover {
  text-decoration: underline;
}

a.btn-white:hover {
  color: rgb(255, 51, 102);
}

a.btn-white {
  cursor: pointer;
  display: inline-block;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  color: rgb(23, 25, 29);
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.12) 0px 20px 40px 0px;
  text-decoration: none;
  border-radius: 999em;
  transition: color 200ms ease-in-out 0s, background-color, box-shadow,
    transform, fill;
  padding: 15.25px 32px;
  border: none;
  margin-bottom: 133px;
  margin-top: 16px;
  font-weight: 700;
}

.section-pic {
  width: 600px;
}

.pink-background {
  background-color: rgb(255, 51, 102);
  color: #fff;
}

.section.pink-background h2 {
  color: #fff;
}

.column {
  /*margin-bottom: 75px;
  margin-top: 75px;*/
  padding-right: 0px;
  padding-left: 0px;
}

.column .column-content {
  padding: 30px;
  max-width: 100%;
}

.icon-wrapper {
  text-align: left;
  padding: 29px 0;
  height: 58px;
}

.icon {
  height: 57px;
}

.icon.medium {
  height: 51px;
}

.icon.small {
  height: 44px;
}

.text-dark {
  color: rgb(23, 25, 29);
}

.border-top {
  border-top: 2px solid rgb(222, 224, 227);
}

.column h3 {
  font-size: 24px;
  font-size: 24px;
  letter-spacing: 0px;
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.3;
  font-weight: 500;
  color: rgb(23, 25, 29);
  margin: 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeSpeed;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeSpeed;
  padding-bottom: calc(var(--cel, 2.5vw) * 0.5);
  cursor: pointer;
  text-align: left;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  letter-spacing: 0px;
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.3;
  font-weight: 500;
  color: rgb(23, 25, 29);
  margin: 0px;
}

.container .column p {
  font-size: 18px;
  letter-spacing: 0.12px;
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.5;
  font-weight: 400;
  color: rgb(23, 25, 29);
  margin: 0px;
  text-align: left;
}

.section {
  display: block;
}

.section h2 {
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.08;
  font-weight: 500;
  color: rgb(23, 25, 29);
  margin: 0px 0px 0px;
}

@media (min-width: 414px) {
  .section {
    padding-top: calc(var(--cel, 2.5vw) * 2);
  }

  .section h2 {
    margin-bottom: calc(var(--cel, 2.5vw) * 0.5);
    letter-spacing: -1px;
    font-size: 40px;
  }
}

.overlay {
  position: absolute;
  width: 100%;
  margin-top: 0;
  top: 0;
  height: 99%;
}

.header-background-video {
  width: 100%;
  max-width:1200px;
  margin: -15px;
  overflow: hidden;
}

.vue-video-section__video-element {
  width: 100%;
  margin: -15px;
}

.btn-wrapper {
  text-align: center;
}

.container p {
  font-size: calc(20px + (4 * (100vw - 800px)) / 800);
  letter-spacing: 0px;
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.3;
  font-weight: 500;
  margin: 0px;
}

.container {
  width: calc(var(--cel, 2.5vw) * 28);
}

.content h1 {
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.08;
  font-weight: 500;
}

@media (min-width: 414px) {
  .logo-wrapper {
    margin-left: 6%;
  }

  .custom {
    font-size: 21px;
    height: 77px;
    float: right;
    text-align: left;
    padding-top: 35px;
    margin-right: 3%;
  }

  .header .list-item {
    margin: 0 17px 0 0;
  }

  .word-separator {
    display: none;
  }

  .content h1 {
    margin-bottom: calc(var(--cel, 2.5vw) * 2);
    margin-bottom: calc(var(--cel, 2.5vw) * 0.5);
    font-size: calc(70px + (2 * (100vw - 768px)) / 672);
    letter-spacing: calc(-0.75px + (-0.25 * (100vw - 800px)) / 800);
    margin-top: calc(var(--cel, 2.5vw) * 1.3);
  }

  .title {
    font-size: calc(30px + (2 * (100vw - 800px)) / 800);
  }

  .container {
    margin: 220px auto;
    width: calc(var(--cel, 2.5vw) * 28);
  }

  .section .container {
    margin: 40px auto;
  }

  .container .btn-red {
    margin-top: calc(var(--cel, 2.5vw) * 0.5);
    font-size: calc(20px + (2 * (100vw - 800px)) / 800);
    padding: calc(40px + (8 * (100vw - 800px)) / 800);
    padding-bottom: calc(18px + (4 * (100vw - 800px)) / 800);
    padding-top: calc(18px + (4 * (100vw - 800px)) / 800);
  }
}

.only-mobile-device {
  visibility: hidden;
}

@media (max-width: 414px) {
  .no-mobile-device {
    height: 0;
    width: 0;
    visibility: hidden;
  }

  .logo-wrapper {
    margin-left: 10%;
  }

  .only-mobile-device {
    visibility: visible;
  }

  .custom {
    font-size: 21px;
    height: 38px;
    float: right;
    text-align: left;
    padding-top: 35px;
    margin-right: 10%;
  }

  .free {
    display: none;
  }

  .header .list-item {
    font-size: 19px;
    margin: 0;
    text-decoration: underline;
  }

  .content h1 {
    margin-bottom: calc(var(--cel, 2.5vw) * 2);
    letter-spacing: calc(-0.5px + (-0.25 * (100vw - 400px)) / 400);
    font-size: calc(32px + (16 * (100vw - 400px)) / 400);
  }

  .title {
    font-size: calc(20px + (16 * (100vw - 400px)) / 400);
  }

  .title .subcategory {
    font-size: calc(13px + (16 * (100vw - 400px)) / 400);
    margin-left: 7px;
    padding-left: 13px;
  }

  .container {
    margin: 78px auto;
    width: calc(var(--cel, 2.5vw) * 28);
  }

  .section.pink-background .container {
    padding-top: 78px;
  }

  .container .btn-red {
    margin: 120px auto;
    margin-top: calc(var(--cel, 2.5vw) * 4);
  }
}

.content {
  text-align: center;
}

.container .btn-wrapper .btn-red {
  padding: calc(40px + (8 * (100vw - 800px)) / 800);
  padding-bottom: calc(18px + (4 * (100vw - 800px)) / 800);
  padding-top: calc(18px + (4 * (100vw - 800px)) / 800);
  cursor: pointer;
  display: inline-block;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  color: rgb(255, 255, 255);
  background-color: rgb(255, 51, 102);
  box-shadow: rgba(0, 0, 0, 0.12) 0px 20px 40px 0px;
  text-decoration: none;
  border-radius: 999em;
  transition: color 200ms ease-in-out 0s, background-color, box-shadow,
    transform, fill;

  letter-spacing: 0px;
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.12;
  font-weight: 700;
  color: inherit;
  text-align: center;
  margin: 0px;
}

.btn-red {
  cursor: pointer;
  display: inline-block;
  position: relative;
  user-select: none;
  vertical-align: middle;
  color: rgb(255, 255, 255);
  background-color: rgb(255, 51, 102);
  box-shadow: rgba(0, 0, 0, 0.12) 0px 20px 40px 0px;
  text-decoration: none;
  border-radius: 999em;
  transition: color 200ms ease-in-out 0s, background-color, box-shadow,
    transform, fill;
  padding: 5.5px 21px;
  line-height: 29px;
}

.subcategory {
  font-size: 20px;
  border-left: solid 1px;
  margin-left: 15px;
  padding-left: 16px;
  padding-top: 3px;
  vertical-align: middle;
}

.header {
  display: block;
  width: 100%;
  min-height: 606px;
  max-height: 800px;
  position: relative;
  top: 0;
  overflow: hidden;
}

.logo-wrapper {
  padding-top: 29px;
  height: 33px;
  padding-bottom: 36px;
  display: inline-block;
  box-sizing: border-box;
}
.header .codelos-logo {
  float: left;
  font-size: 19px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  line-height: 22px;
  width: 41px;
  border-radius: 19px;
  background-color: rgb(255, 51, 102);
  text-align: left;
  padding: 5px 10px 1px 9px;
  transform: rotate(-10deg);
}
.title {
  float: left;
  margin: 6px 20px 0px 10px;
  padding-right: 23px;
  line-height: 33px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  font-family: "Nunito", sans-serif;
}

.header ul li {
  list-style: none;
  display: inline;
  font-family: "Open Sans", open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;

  cursor: pointer;
}

.header ul {
  padding: 0;
  margin: 0;
  height: 33px;
}

.header ul li a {
  text-decoration: none;
  display: block;
  height: 31px;
}

.header ul li a.active {
  padding: 0;
  margin: 0;
  margin-left: 75px;
  display: block;
  height: 29px;
}

.header ul li a:hover {
  color: #ffff;
}

.header ul li a:visited {
  text-decoration: none;
}

.header .list-item {
  display: inline-block;
}

.header .menu2-bar .list-item {
  margin: 0 75px 0 0;
  vertical-align: top;
}

.header .menu2-bar .list-item.active {
  margin: 0 75px 0 0;
  border-bottom: solid 2px rgb(255, 51, 102);
}

.header .Button__button___1FrBC {
  /*float: right;*/
  background: none;
  border: none;
  text-transform: none;
  color: #9aa4b3;
  display: inline;
  font-family: "Open Sans", open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  color: #9aa4b3;
  cursor: pointer;
  padding: none;
}

.toggle-list-wrapper .item.more:hover {
  background-color: #fff;
}

.header ul li a.more:hover {
  background-position: -62px 3px;
}
a.sign-out {
  position: absolute;
  right: 20px;
  top: -24px;
}
.toggle-list-wrapper {
  background-color: #ffff;
  position: relative;
  left: -53px;
  top: 36px;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
  max-width: 600px;
  overflow: scroll;
  z-index: 2;
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 127px;
  margin-top: -47px;
}

.toggle-list-wrapper .item {
  cursor: pointer;
  padding: 9px 23px;
  text-align: left;
  height: fit-content;
  margin: 0;
  font-weight: 300;
  color: #464d5d;
  font-size: 11px;
}
.toggle-list-wrapper .item.last-item {
  border-top: solid 1px #e1e4ea;
}

.toggle-list-wrapper .item:hover {
  background-color: #f0f0f0;
}

.playsinline {
  height: 100%;
}

video {
  min-height: 100%;
  min-width: 100%;
  max-height: 100%;
  max-width: 100%;
}
</style>